<template>
  <div class="grid seatdetail" :class="{ active: checkDay(seat.guests)||fromsearch||fromresult, free: !checkDay(seat.guests)||!fromsearch||!fromresult }">
	<!-- {{checkDay(seat.guests)}} -->
	<!-- {{seat}} -->
	<!-- <unicon name="draggabledots" height="24" width="24" fill="#fff" /> -->

	<div class="grid options" v-if="checkDay(seat.guests) && ($store.state.user.privileges.admin||$store.state.user.privileges.editbeach)" key="options">
			<span class="grid action" @click="addOmbrello(filteredGuest)">
				<unicon name="book-medical" fill="#fff" />
				<label>aggiungi ombrellone</label>
			</span>
<!--             <span class="grid action" @click="addOmbrello(filteredGuest)">
				<unicon name="user-plus" fill="#fff" />
				<label>aggiungi ospite</label>
			</span> -->
			<span class="grid action" @click="seeqr = true, options = false">
				<unicon name="qrcode-scan" fill="#fff" />
				<label>Beachpass</label>
			</span>
			<span class="grid action" @click="cancel = true, options = false">
				<unicon name="trash" fill="#fff" />
				<label>cancella</label>
			</span>
		</div>

	<transition-group name="slide-fade">
		<h2 v-if="edit" key="ombrid">{{guest.ombrid}}</h2>

		<vc-date-picker
					mode='range'
					is-inline
					color="green"
					v-model="range"
					:from-date="fromdate"
					locale="it-IT"
					:disabled-dates="disabledDatesEdit"
					key="range"
					v-if="edit && !changeitems"
					:attributes="attributes"
					ref="picker"
					:masks="masks"
				/>

		<vc-date-picker
					mode='range'
					is-inline
					color="green"
					v-model="range2"
					:from-date="fromdate"
					locale="it-IT"
					:available-dates="enabledDatesEdit"
					key="rangechangeitems"
					v-if="edit && changeitems"
					:attributes="periodes"
					ref="picker"
					:masks="masks"
					@input="updateDateRange"
				>
				<template #day-popover="{periodes, dayTitle}">
					<div>
						<!-- {{ customData }} -->
						{{dayTitle}}
						<!-- {{day}} -->
						{{periodes}}
					  <li
						v-for="{item, key} in periodes"
						:key="key">
						{{ item }}
						{{key}}
					  </li>
					</div>
				  </template>

			  </vc-date-picker>

	</transition-group>

	<div class="grid details active" :class="{scaled: options}" v-if="checkDay(seat.guests)||fromsearch||fromresult">

		<!-- {{filteredGuest}} -->
		<!-- {{seat._id}} -->
		<!-- {{matchedGuest.ombrelloni}} -->
		<!-- <p>{{periodes}}</p> -->
		<!-- <p>{{guest.items}}</p> -->
		<!-- <p>{{enabledDatesEdit}}</p> -->
		<!-- {{$options.filters.toDrop(guest.items)}} -->
		<div v-if="edit && !cancel && !checkout && !seeqr" @click="changeitems = !changeitems">
			<div v-for="(item, index) in $options.filters.toDrop(guest.items)" :key="index" class="grid extraitems">
				<div class="grid" style="align-content: center; padding-left: 16px;">
					<small><strong>{{item.period.start}} - {{item.period.end}}</strong></small>
				</div>
				<!-- <div class="grid">
					<span style="width: 100%; display: block;" v-for="(itemi, indexi) in item.items" :key="indexi">
						<span style="filter: invert(1);" v-html="itemi.icon"></span>
					</span>
				</div> -->
				<div class="grid items" key="items" style="margin: 0px;">
					<div v-for="(itemi, indexi) in item.items" :key="indexi" class="grid item">
						<span class="grid badge">{{itemi.num}}</span>
						<span class="grid icon" v-html="itemi.icon" style="height: 16px;"></span>
						<!-- <span class="grid name">{{itemi.name}}</span> -->
					</div>
				</div>
				<div class="grid actions" v-if="changeitems">
					<unicon name="trash" height="16px" @click="guest.items.splice((index+1), 1)" />
				</div>
			</div>
		</div>
		<!-- <p>{{range}}</p> -->
		<!-- <p>{{range2}}</p> -->

		<transition-group name="fade">

		<div key="seat" class="grid seats" v-if="!edit && !cancel && !checkout && !seeqr">
			<div v-for="(ombrellone, index) in $options.filters.toCron(matchedGuest.ombrelloni)" :key="index" class="grid seat" :class="{active: checkActive(ombrellone), inactive: !checkActive(ombrellone)}"  @click="edit = !edit, assign(filteredGuest, ombrellone), range = {'start': ombrellone.arrival, 'end': ombrellone.departure}, options = false">
				<!-- <span class="grid id">{{ombrellone.ombrid}}</span> -->
				<span class="grid id">{{toOmbrid(ombrellone.ombrelloneid)}}</span>
				<span class="grid name" >{{filteredGuest.name}}</span>
				<span class="grid stay" >{{ombrellone.arrival}} - {{ombrellone.departure}}</span>

				<div class="grid items" key="items" style="margin: 0px auto 0;">
					<!-- {{$options.filters.toToday(filteredGuest.items)}} -->
					<!-- {{filteredGuest.items}} -->
					<!-- {{ombrellone.items}} -->
					<div v-for="(item, index) in $options.filters.toToday(ombrellone.items, today)" :key="index" class="grid item">
						<span class="grid badge">{{item.num}}</span>
						<span class="grid icon" v-html="item.icon"></span>
						<span class="grid name">{{item.name}}</span>
					</div>
				</div>

				<span class="grid room" v-if="hotel.settings.room">{{filteredGuest.room}}</span>
			</div>
			<!-- <div key="arrow">
				<unicon name="angle-double-down" height="24" width="24" fill="#FF0132" v-if="matchedGuest.ombrelloni.length > 0" />
			</div> -->
		</div>

		

		<!-- <div key="otherseats" v-if="!edit">
			<p v-for="ombrellone in matchedGuest.ombrelloni" :key="ombrellone.ombrelloneid">{{ombrellone.ombrid}} {{ombrellone.arrival}} - {{ombrellone.departure}}</p>
		</div> -->

		<div class="grid checkout" v-if="checkout && !edit && !cancel && hotel.cashier && !seeqr" key="checkout">
			<div class="grid seat " v-for="(ombrellone, index) in $options.filters.toCron(matchedGuest.ombrelloni)" :key="index" v-loading="guestloading||ombrelloniloading">
				<!-- {{matchedGuest.ombrelloni}} -->
				<span class="grid id">{{toOmbrid(ombrellone.ombrelloneid)}}</span>
				<div class="grid data">
					<span class="grid name" >{{filteredGuest.name}}</span>
					<span class="grid stay" >{{ombrellone.arrival}} - {{ombrellone.departure}}</span>
				</div>
				<span class="grid paid">
					<unicon name="money-bill-slash" height="20" width="20" fill="#FF0132" v-if="!ombrellone.paid" />
					<unicon name="money-bill" height="20" width="20" fill="#12C300" v-if="ombrellone.paid" />
				</span>

				<div class="grid bill">
					<!-- {{bill.baseprice}} -->
<!--                    <span class="grid item">
						<span>Giorni in spiaggia</span>
						<span>{{$options.filters.toBill(ombrellone, seasons).dates.length}}</span>
					</span> -->
					<!-- <span class="grid item">
						<span>ombrellone</span>
						<span>{{toBill(ombrellone, seasons).ombritems}}</span>
					</span> -->
	  <!--               <span class="grid item" v-for="(bill, index) in toBill(ombrellone)" :key="index">
						<span>{{index}}</span>
						<span>€ {{bill}}</span>
					</span> -->
					<span class="grid item">
						<span>Prezzo ombrellone</span>
						<!-- {{toBill(ombrellone).generalbill}} -->
						<span v-if="toBill(ombrellone).baseprice === '0.00'" style="display: grid; grid-auto-flow: column; grid-column-gap: 4px;">
							<el-tooltip content="Controlla la stagione" placement="top">
								<unicon name="question-circle" height="16" fill="#808080" />
							</el-tooltip>
							<span>€ {{toBill(ombrellone).baseprice}}</span>
						</span>
						<span v-else>€ {{toBill(ombrellone).baseprice}}</span>
					</span>
					<span class="grid item">
						<span>Prezzo sdraio etc</span>
						<span>€ {{toBill(ombrellone).items}}</span>
					</span>
					<span class="grid item total">
						<span>Totale</span>
						<span>€ {{toBill(ombrellone).total}}</span>
					</span>
				</div>

			</div>

		</div>

		<!-- <div class="grid ombrellonebill" key="ombrellonebill" @click="checkout = true" v-if="!checkout && hotel.cashier && !edit || hotel.cashier && checkout && matchedGuest.ombrelloni.length > 1 && !edit"> -->
		<div class="grid ombrellonebill" :class="{ok: checkBill(matchedGuest.ombrelloni), unpaid: !checkBill(matchedGuest.ombrelloni)}" key="ombrellonebill" @click="checkout = true, options = false" v-if="!checkout && hotel.cashier && !edit && !cancel && !seeqr || hotel.cashier && checkout && matchedGuest.ombrelloni.length > 1" v-loading="guestloading||ombrelloniloading">
			<!-- <span class="grid path"></span> -->
			<span class="title">Totale</span>
			<!-- <span class="days">{{ombrellonebill.days.length}}</span> -->
			<span class="amount" :class="{ok: checkBill(matchedGuest.ombrelloni), unpaid: !checkBill(matchedGuest.ombrelloni)}">€ {{ombrellonebill.total}}</span>
			<span class="error" v-if="$store.state.hotels.activehotel.seasons.length === 0"><small>nessuna stagione definita</small></span>
			<span class="grid paid">
				<el-tooltip placement="top" v-if="ombrellonebill &&  ombrellonebill.alert && ombrellonebill.alert.active">
					<div slot="content">
						<p v-for="(message, index) in ombrellonebill.alert.messages" :key="index">
							<small>{{message}}</small>
						</p>
					</div>
					<unicon name="exclamation-triangle" height="20" width="20" fill="#FF8401"  />
				</el-tooltip>
				<unicon name="money-bill-slash" height="20" width="20" fill="#FF0132" v-if="!checkBill(matchedGuest.ombrelloni)" />
				<unicon name="money-bill" height="20" width="20" fill="#12C300" v-if="checkBill(matchedGuest.ombrelloni)" />
			</span>
		</div>

		<!-- <div key="seatstocancel" class="grid seats"> -->
			<el-checkbox-group v-model="canceldates" key="canceldates" size="mini" v-if="!edit && cancel" class="grid seats">
				<el-checkbox v-for="ombrellone in matchedGuest.ombrelloni" :key="ombrellone.ombrelloneid" :label="ombrellone" class="grid seat inactive">
					<span class="grid id">{{toOmbrid(ombrellone.ombrelloneid)}}</span>
					<span class="grid stay" >{{ombrellone.arrival}} - {{ombrellone.departure}}</span>
				</el-checkbox>
			</el-checkbox-group>
		<!-- </div> -->

		<div class="grid seeqr" style="align-content: center; justify-items: center;" v-if="seeqr" key="seeqr">
			<span v-if="matchedGuest.passid" style="margin-bottom: 16px;">
				<small>fai vedere questo QR al tuo ospite</small>
			</span>
			<span v-else style="max-width: 320px; word-break: break-word; text-align: center;"><small>Crea il <strong>codice QR</strong> da mostrare al tuo ospite per fargli <strong>salvare il Beachpass sul proprio smartphone</strong></small></span>
			<!-- {{matchedPass.passid}} -->
			<!-- {{matchedGuest.passid}} -->
			<qrcode v-if="matchedGuest.passid" :value="'https://spiaggia.ombrelleria.com/api/get/pass/' + matchedGuest.passid" :options="{ width: 200 }"></qrcode>
			<!-- <qrcode v-if="matchedGuest.passid" :value="'https://dexter.node.systems:44567/api/get/pass/' + matchedGuest.passid" :options="{ width: 200 }"></qrcode> -->
			<div class="grid qrstate" style="grid-auto-flow: column; justify-content: center; width: 100%; margin-top: 24px;">
				<span v-if="matchedPass" class="grid" style="grid-auto-flow: column; grid-column-gap: 8px; align-items: center;">
					<!-- <unicon name="download-alt" height="20" width="20" fill="#12C300" v-if="matchedPass.deviceid && matchedPass.pushToken" />
					<unicon name="download-alt" height="20" width="20" fill="#333" v-else /> -->
					<button class="btn sm" @click="$emit('sendPushmessage', matchedGuest)" v-if="matchedPass.deviceid && matchedPass.pushToken">
						<unicon name="bell" height="20" width="20" fill="#12C300" />
						<small>manda messaggio </small>
					</button>
					<button class="btn sm" @click="$emit('sendPassmail', matchedGuest)">
						<unicon name="envelope-share" height="20" width="20" fill="#12C300" />
						<small>invia pass</small>
					</button>
				</span>
			</div>
		</div>


		<div class="grid btnlist" :class="{three: !checkBill(matchedGuest.ombrelloni)}" key="btnlist" v-if="!edit">

			<button class="btn  " key="dots" v-if="!edit" @click="(edit || cancel || checkout || seeqr) ? (edit = false, cancel = false, checkout = false, seeqr = false) : options = !options">
				<unicon name="draggabledots" height="16" width="16" fill="#333" v-if="!checkout && !cancel && !options && !seeqr" />
				<unicon name="angle-down" height="16" width="16" fill="#333" v-else-if="options" />
				<unicon name="angle-left-b" height="16" width="16" fill="#333" v-else />
			</button>

			<button type="button" class="btn" @click="$emit('closeseatDialog')" v-if="!checkBill(matchedGuest.ombrelloni)">
				<unicon name="times" height="16" width="16" fill="#333"  />
			</button>

			<button class="btn dark block" key="btnclose" v-if="!edit && !cancel && checkBill(matchedGuest.ombrelloni)" @click="$emit('closeseatDialog')">
				<span >chiudi</span>
			</button>

			<button class="btn dark block" key="btncheckout" v-if="!edit && !cancel && hotel.cashier && !checkBill(matchedGuest.ombrelloni) && !seeqr" @click="checkout ? checkoutGuest() : (checkout = true, options = false)">
			<!-- <button class="btn dark block" key="btn" v-if="!edit && !cancel && hotel.cashier" @click="checkout ? checkoutGuest() : checkout = true"> -->
				<span v-if="!checkout">checkout</span>
				<span v-if="checkout && !checkBill(matchedGuest.ombrelloni)">conferma checkout</span>
				<!-- <span v-if="checkout">conferma checkout</span> -->
			</button>

			<button class="btn green block" key="btnqr" v-if="seeqr && !matchedGuest.passid" @click="generatePass(matchedGuest)">
				<span >crea qr</span>
			</button>

			<button class="btn red block" key="btn" v-if="!edit && cancel" @click="deleteGuest(filteredGuest)">cancella date</button>

		</div>
		</transition-group>


		<transition-group name="fade">
		<el-form key="form" ref="seatform" :rules="rules" :model="guest" status-icon v-if="edit">
			
			<div class="grid details" :class="{edit: edit}">
				<!-- <span class="grid">{{seat._id}}</span> -->
				<!-- <transition-group name="slide-fade"> -->
					<!-- {{range}} -->
					<!-- <p>{{disabledDatesEdit}}</p> -->
					<!-- {{guest}} -->
					<!-- {{$options.filters.toToday(guest.items)}} -->
				<div class="grid items" key="items" v-if="!changeitems" @click="changeitems = !changeitems">
					<!-- <span v-for="item in hotel.items" :key="item.icon" v-html="item.icon"></span> -->
					<div v-for="item in $options.filters.toToday(guest.items, today)" :key="item.icon" class="grid item">
						<span class="grid badge">{{item.num}}</span>
						<span class="grid icon" v-html="item.icon"></span>
						<span class="grid name">{{item.name}}</span>
					</div>
				</div>

				<div class="grid changeitems" key="changeitems" v-if="changeitems && !insertitems">
					<div v-for="item in $options.filters.toToday(guest.items, today)" :key="item.icon" class="grid item">
						<span class="grid badge">
							<el-form-item><el-input-number v-model="item.num" size="mini" :min="0"></el-input-number></el-form-item>
						</span>
						<span class="grid icon" v-html="item.icon"></span>
						<span class="grid name">{{item.name}}</span>
					</div>
				</div>

				<div class="grid changeitems" key="changeitems" v-if="changeitems && insertitems">
					<div v-for="(item, index) in $options.filters.toLast(guest.items)" :key="index" class="grid item">
						<span class="grid badge">
							<el-form-item><el-input-number v-model="item.num" size="mini" :min="0"></el-input-number></el-form-item>
						</span>
						<span class="grid icon" v-html="item.icon"></span>
						<span class="grid name">{{item.name}}</span>
					</div>
				</div>

				<el-form-item label="Nome" key="name" prop="name" v-if="!changeitems">
					<el-input type="text" v-model="guest.name" name="name"></el-input>
				</el-form-item>

				<el-form-item label="Camera" key="room" v-if="hotel.settings.room && !changeitems">
					<el-input type="text" v-model="guest.room"></el-input>
				</el-form-item>

				<!-- <div class="grid btnlist" :class="{three: !checkBill(matchedGuest.ombrelloni)}" key="btnlist" v-if="!edit"> -->
				<div class="grid btnlist" key="btnlist" v-if="edit">

					<button type="button" class="btn" @click="changeitems ? changeitems = false : edit = false, range2 = {}">
						<!-- <unicon name="times" height="16" width="16" fill="#333" v-if="!changeitems" /> -->
						<unicon name="angle-left-b" height="16" width="16" fill="#333" />
					</button>

					<button type="button" class="btn" @click="$emit('closeseatDialog')">
						<unicon name="times" height="16" width="16" fill="#333"  />
					</button>

					<!-- <el-form-item> -->
						<button type="button" v-if="!changeitems" class="btn green block" @click="update('seatform')" v-loading="loading">update ombrellone</button>
						<button type="button" v-if="changeitems" class="btn green block" @click="changeitems = !changeitems">conferma modifiche</button>
					<!-- </el-form-item> -->

				</div>

			</div>

		</el-form>
		</transition-group>


	</div>

<!--    <transition-group name="slide-fade">
		<div class="grid options" v-if="options" key="options">
			<span class="grid action" @click="addOmbrello(filteredGuest)">
				<unicon name="book-medical" />
				<label>aggiungi ombrellone</label>
			</span>
			<span class="grid action" @click="cancel = true">
				<unicon name="trash" />
				<label>cancella</label>
			</span>
		</div>
	</transition-group> -->

	<div class="grid seat free" v-if="!checkDay(seat.guests)">

		<!-- <p>{{seat}}</p> -->
		<!-- <p>{{bookingdates}}</p> -->

		<el-form ref="seatform" :rules="rules" :model="guest" status-icon class="stayselector">
			
			<el-form-item prop="range">
				<vc-date-picker
					mode='range'
					is-inline
					color="green"
					v-model="range"
					:from-date="fromdate" 
					locale="it-IT"
					:disabled-dates="disabledDates"
					:attributes="bookingdates"
					:masks="masks"
					class="daterange"
					v-if="!steps.payment"
				/>
			</el-form-item>

<!--             <div class="grid seasonal">
				<el-form-item>
					<el-checkbox disabled v-model="guest.seasonal" label="Stagionale" border size="small"></el-checkbox>
				</el-form-item>
			</div> -->

			<!-- {{hotel.items}} -->
			<!-- {{range}} -->
			<div class="grid details">

				<!-- <p>{{items}}</p> -->

				<!-- <p key="g" style="color: #333;">{{items}}</p>
				<p key="g2" style="color: #ddd;">{{$store.state.hotels.activehotel.items}}</p> -->

				<div class="grid checkout" v-if="steps.payment" key="checkout">
					<!-- <div class="grid seat " v-for="(ombrellone, index) in $options.filters.toCron(matchedGuest.ombrelloni)" :key="index" v-loading="guestloading||ombrelloniloading"> -->
					<div class="grid seat ">
						<span class="grid id" style="background-color: transparent; border: 1px solid #ddd;">
							<unicon name="receipt" height="20" width="20" fill="#333" />
						</span>
						<!-- {{guest}} -->
						<div class="grid data">
							<span class="grid name" >{{guest.name}}</span>
							<span class="grid stay" >{{range.start|toDate}} - {{range.end|toDate}}</span>
						</div>
<!-- 						<span class="grid paid">
							<unicon name="money-bill-slash" height="20" width="20" fill="#FF0132" v-if="!ombrellone.paid" />
							<unicon name="money-bill" height="20" width="20" fill="#12C300" v-if="ombrellone.paid" />
						</span> -->

						<div class="grid bill">
							<span class="grid item">
								<span>Prezzo ombrellone</span>
<!-- 								<span v-if="toBill({
									arrival: $options.filters.toDate(range.start),
									departure: $options.filters.toDate(range.end),
									items: [{
										items: guest.items,
										period: {
											start: $options.filters.toDate(range.start),
											end: $options.filters.toDate(range.end)
										}
									}],
									ombrelloneid: seat._id
								}).baseprice === '0.00'" style="display: grid; grid-auto-flow: column; grid-column-gap: 4px;">
									<el-tooltip content="Controlla la stagione" placement="top">
										<unicon name="question-circle" height="16" fill="#808080" />
									</el-tooltip>
									<span>€ {{toBill({
									arrival: $options.filters.toDate(range.start),
									departure: $options.filters.toDate(range.end),
									items: [{
										items: guest.items,
										period: {
											start: $options.filters.toDate(range.start),
											end: $options.filters.toDate(range.end)
										}
									}],
									ombrelloneid: seat._id
								}).baseprice}}</span>
								</span> -->
								<span>€ {{toBill(tmpombrellone).baseprice}}</span>
							</span>
							<span class="grid item">
								<span>Prezzo sdraio etc</span>
								<span>€ {{toBill(tmpombrellone).items}}</span>
							</span>
							<span class="grid item total">
								<span>Totale</span>
								<span>€ {{toBill(tmpombrellone).total}}</span>
							</span>
						</div>

					</div>

					<stripe-element-card
					ref="elementRef"
			      	:pk="pulishableKey"
			      	@token="tokenCreated"/>
			      	<button @click="submit">Generate token</button>

				</div>
				

				<transition-group name="slide-fade" v-if="($store.state.user.privileges.admin||$store.state.user.privileges.editbeach||$store.state.user.privileges.guest)">

					<!-- <p key="asdasd" style="color: #333;">{{seat.guests}}</p> -->

				<div class="grid items" key="items" style="margin: 24px auto;" v-if="steps.range && !changeitems" @click="changeitems = !changeitems">
					<div v-for="(item, index) in guest.items" :key="index" class="grid item">
						<span class="grid badge">{{item.num}}</span>
						<span class="grid icon" v-html="item.icon"></span>
						<span class="grid name">{{item.name}}</span>
					</div>
				</div>

				<div class="grid changeitems" key="changeitems" v-if="changeitems">
					<div v-for="(item, index) in guest.items" :key="index" class="grid item">
						<span class="grid badge">
							<el-form-item><el-input-number v-model="item.num" size="mini" :min="0"></el-input-number></el-form-item>
						</span>
						<span class="grid icon" v-html="item.icon"></span>
						<span class="grid name">{{item.name}}</span>
					</div>
				</div>

				<!-- {{add.guest}} -->

				<p style="color: #333; text-align: center;" key="desc" v-if="!steps.range && !steps.payment">Seleziona un periodo</p>
				<p style="color: #333; text-align: center;" key="desc2" v-if="!steps.range && add.open">da aggiungere a {{add.guest.name}}</p>

				<el-form-item label="Nome" key="name" prop="name" v-if="steps.range && !add.open && !changeitems">
					<el-input type="text" v-model="guest.name" name="name"></el-input>
				</el-form-item>

				<el-form-item label="Indirizzo email" key="email" prop="email" v-if="steps.range && !add.open && !changeitems && hotel.settings.publicbooking && $store.state.user.privileges.guest">
					<el-input type="text" v-model="guest.email" name="email"></el-input>
				</el-form-item>

				<!-- <StripeCheckout
				pk="pk_test_51Hid9eISox9uI0WOLRidGs9l2uegQVx1eP7CGk1eM5bL3mhVeINljITZRcVsAgJTL2I2DHHcWGuwlOmWp0BHka4J00SsNNETD3"
				mode="payment"
				ref="checkoutRef"
				:line-items="lineItems"
				v-if="steps.range && !add.open && !changeitems && hotel.settings.publicbooking && $store.state.user.privileges.guest"
				key="stripe"
				>
				</StripeCheckout> -->


				<el-form-item label="Camera" key="room" v-if="hotel.settings.room && !changeitems && !add.open && steps.range">
					<el-input type="text" v-model="guest.room"></el-input>
				</el-form-item>

				</transition-group>

				<!-- <div class="spacer xs"></div> -->

				<!-- <el-form-item> -->
					<div class="grid btnlist" :class="{three: steps.payment}" key="btnlist" v-if="!edit">
						<button type="button" class="btn" @click="changeitems ? changeitems = false : $emit('closeseatDialog')">
							<unicon name="times" height="16" width="16" fill="#333" v-if="!changeitems" />
							<unicon name="angle-left-b" height="16" width="16" fill="#333" v-else />
						</button>
						<button type="button" class="btn" @click="steps.payment = false, steps.range = true" v-if="steps.payment">
							<unicon name="angle-left-b" height="16" width="16" fill="#333" />
						</button>
						<button type="button" v-if="!changeitems && ($store.state.user.privileges.admin && !$store.state.user.privileges.guest||$store.state.user.privileges.editbeach && $store.state.user.privileges.guest||$store.state.user.privileges.guest && !hotel.cashier)" class="btn green block" @click="add.open ? addSeat('seatform') : save('seatform')" :disabled="!steps.range && !steps.name" v-loading="loading"><span v-if="!add.open">salva ombrellone</span><span v-if="add.open">aggiungi ombrellone</span></button>
						<button type="button" v-if="!changeitems && $store.state.user.privileges.guest && hotel.cashier" class="btn green block" @click="steps.payment ? submit : proceedtoPayment('seatform')" :disabled="!steps.range && !steps.payment" v-loading="loading"><span v-if="!steps.payment">procedi</span><span v-if="steps.payment">conferma pagamento</span></button>
						<button type="button" v-if="changeitems" class="btn green block" @click="changeitems = !changeitems">conferma modifiche</button>
					</div>
				<!-- </el-form-item> -->

			</div>

		</el-form>

	</div>

  </div>
</template>

<script>
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)
import _ from 'lodash'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
export default {
  name: 'Seat',
  props: {
	seat: Object,
	checkDay: Function,
	today: [Object, Date],
	add: Object,
	move: Object,
	bookingrange: Object,
	ombrelloni: Array,
	fromsearch: Boolean,
	fromresult: Boolean
  },
  data () {
  	this.pulishableKey = 'pk_test_51Hid9eISox9uI0WOLRidGs9l2uegQVx1eP7CGk1eM5bL3mhVeINljITZRcVsAgJTL2I2DHHcWGuwlOmWp0BHka4J00SsNNETD3'
	var checkRange = (rule, value, callback) => {
		// console.log(moment(this.range.start).isValid(), moment(this.range.end).isValid())
		console.log(this.range)
		if (this.range.start === '' && this.range.end === '') {
			callback(new Error('prego inserire un periodo'));
		} else {
			// if (this.range.start !== '') {
			//  this.$refs.seatform.validateField('checkrange');
			// }
			this.$refs.seatform.validateField('checkrange');
			callback();
		}
	}
	return {
		token: null,
		masks: {
			input: ['DD.MM.YYYY'],
			data: ['DD.MM.YYYY']
		},
		checkout: false,
		options: false,
		guest: {
			ombrid: '',
			items: [],
			seasonal: false
		},
		guestid: '',
		fromdate: moment(this.today).toDate(),
		edit: false,
		changeitems: false,
		cancel: false,
		seeqr: false,
		canceldates: [],
		steps: {
			range: false,
			name: false,
			room: false,
			payment: false
		},
		loading: false,
		range: {
			start: '',
			end: ''
		},
		range2: {
			start: '',
			end: ''
		},
		insertitems: false,
		// hotelitems: JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel.items)),
		rules: {
			name: [
				{ required: true, message: 'prego inserire un nome', trigger: 'blur' }
			],
			email: [
				{ required: true, type: 'email', message: 'prego inserire un indirizzo email', trigger: 'blur' }
			],
			range: [
				{ validator: checkRange, trigger: 'blur' }
			]
		}
	}
  },
  components: {
	StripeElementCard
  },
  methods: {
  	submit (e) {
      // this will trigger the process
      this.$refs.elementRef.submit()
      e.preventDefault()
    },
    tokenCreated (token) {
      console.log(token)
      // handle the token
      // send it to your server
    },
	toOmbrid (ombrelloneid) {
		// console.log(ombrelloneid)
		return _.find(this.ombrelloni, (o) => { return o._id === ombrelloneid }).ombrid
	},
	generatePass (matchedGuest) {
		console.log(matchedGuest)
		this.$store.dispatch('guests/generatePass', { guest: matchedGuest })
	},
	pushItems () {

	},
	updateDateRange (range) {
		console.log('range ', range)
		this.insertitems = true
		// var hotelitems = JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel.items))
		// _.mapValues(this.hotelitems, function (o) {
		//     o.num = 0
		// })
		// console.log(this.hotelitems)
		var newperiod = {
			period: {
				start: moment(range.start).format('DD.MM.YYYY'),
				end: moment(range.end).format('DD.MM.YYYY')
			},
			items: JSON.parse(JSON.stringify(_.last(this.guest.items).items))
		}
		console.log(newperiod)
		this.guest.items.push(newperiod)
		// var merged = _.merge(this.guest.items)
		// console.log('merged ', merged)
		// var stay = moment.range(moment(this.range.start, 'DD.MM.YYYY'), moment(this.range.end, 'DD.MM.YYYY'))
		// var itemsrange = moment.range(this.range2.start, this.range2.end)
		// itemsrange.overlaps(stay)
		// var overlaps = await itemsrange.overlaps(stay, { adjacent: true })
		// var isBetween = await moment(this.today).isBetween(moment(ombrellone.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(ombrellone.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '()')
		// console.log('overlaps ', stay, overlaps)
		// var isarrival = moment(range.start).isSame(moment(this.range.start, 'DD.MM.YYYY'))
		// var untilend = moment(range.end).isSame(moment(this.range.end, 'DD.MM.YYYY'))
		// console.log(isarrival, untilend)
		// if (untilend) {
		//     console.log(this.guest.items, range.start)
		//     _.last(this.guest.items).period.end = moment(range.start).subtract(1, 'd').format('DD.MM.YYYY')
		//     this.guest.items.push({
		//         period: {
		//             start: moment(range.start).format('DD.MM.YYYY'),
		//             end: moment(range.end).format('DD.MM.YYYY')
		//         },
		//         items: JSON.parse(JSON.stringify(_.last(this.guest.items).items))
		//     })
		//     console.log(this.guest.items)
		// }
		// if (isarrival) {
		//     console.log('isarrival: ', this.guest.items, range.start)
		//     // _.last(this.guest.items).period.end = moment(range.start).subtract(1, 'd').format('DD.MM.YYYY')
		//     if (untilend) {
		//         this.guest.items[0] = {
		//             period: {
		//                 start: moment(range.start).format('DD.MM.YYYY'),
		//                 end: moment(range.end).format('DD.MM.YYYY')
		//             },
		//             items: JSON.parse(JSON.stringify(_.last(this.guest.items).items))
		//         }
		//     } else {
		//         _.last(this.guest.items).period.end = moment(range.end).format('DD.MM.YYYY')
		//         this.guest.items.push({
		//             period: {
		//                 start: moment(range.end).add(1, 'd').format('DD.MM.YYYY'),
		//                 end: this.range.end
		//             },
		//             items: JSON.parse(JSON.stringify(_.last(this.guest.items).items))
		//         })
		//     }
		//     console.log(this.guest.items)
		// }
		// var self = this
		// var filtered = this.guest.items.filter(function (o) {
		//     // console.log(o.period.start, o.period.end, moment(range.start).format('DD.MM.YYYY'), moment(range.end).format('DD.MM.YYYY'), (moment(range.start).isBetween(moment(o.period.start, 'DD.MM.YYYY'), moment(o.period.end, 'DD.MM.YYYY'), 'day', '[]') || moment(range.end).isBetween(moment(o.period.start, 'DD.MM.YYYY'), moment(o.period.end, 'DD.MM.YYYY'), 'day', '[]')))
		//     // return (moment(range.start).isBetween(moment(o.period.start, 'DD.MM.YYYY'), moment(o.period.end, 'DD.MM.YYYY'), 'day', '[]') || moment(range.end).isBetween(moment(o.period.start, 'DD.MM.YYYY'), moment(o.period.end, 'DD.MM.YYYY'), 'day', '[]'))
		//     // console.log(o.period.start, o.period.start !== '13.01.2021')
		//     // return o.period.start !== '13.01.2021'
		//     var period = moment.range(moment(o.period.start, 'DD.MM.YYYY'), moment(o.period.end, 'DD.MM.YYYY'))
		//     var itemsrange = moment.range(self.range2.start, self.range2.end)
		//     console.log(o.period.start, o.period.end, !itemsrange.overlaps(period))
		//     return !itemsrange.overlaps(period)
		// })
		// console.log('filtered ', filtered)
		// // this.guest.items = filtered
		// console.log('filtered2 ', filtered)
		// console.log('filtered ', this.guest.items)
		// this.guest.items.push({
		//     period: {
		//         start: moment(range.start).format('DD.MM.YYYY'),
		//         end: moment(range.end).format('DD.MM.YYYY')
		//     }
		// })
	},
	checkBill (ombrelloni) {
		// console.table(ombrelloni)
		// console.warn(_.filter(ombrelloni, function (o) {
		//  return o.paid === undefined || !o.paid
		// }))
		var unpaid = _.filter(ombrelloni, function (o) {
			return o.paid === undefined || !o.paid
		})
		// if (unpaid.length > 0) {
		//  return false
		// } else {
		//  return true
		// }
		switch(unpaid.length > 0 && this.hotel.cashier) {
			case true:
				return false
			case false:
				return true
		}
		// return _.find(ombrelloni, function (o) {
		//  console.log(o.paid)
		//  if (o.paid === undefined || !o.paid) { return false } else { return true }
		// })
	},
	checkActive (ombrellone) {
		// console.log('checkActive: ', ombrellone.ombrid, this.seat.ombrid, moment(this.today).isBetween(moment(ombrellone.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(ombrellone.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]'))
		return moment(this.today).isBetween(moment(ombrellone.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(ombrellone.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
	},
	moveGuest (value) {
		console.log(value)
		this.$emit('move', value)
	},
	addOmbrello (guest) {
		console.log(guest)
		this.$emit('addOmbrello', guest, this.seat)
	},
	assign (value, ombrellone) {
		if (value.guestid) {
			console.log('ddd', value, ombrellone)
			// this.$emit('changeDate', this.guest)
			this.guestid = value.guestid
			// this.guest = value
			this.guest = {
				name: value.name,
				guestid: value.guestid,
				note: value.note,
				passid: this.matchedGuest.passid,
				room: value.room,
				items: ombrellone.items,
				arrival: ombrellone.arrival,
				departure: ombrellone.departure,
				ombrid: ombrellone.ombrid,
				ombrelloneid: ombrellone.ombrelloneid
			}
			// this.guest.items = ombrellone.items
			// this.guest.arrival = ombrellone.arrival
			// this.guest.departure = ombrellone.departure
			// this.guest.ombrid = ombrellone.ombrid
			// this.$emit('changeDate', this.guest)
		}
	},
	checkoutGuest () {
		console.warn('checkoutGuest')
		this.$store.dispatch('guests/checkoutGuest', { guest: this.matchedGuest })
	},
	save (formName) {
		// var self = this
		// console.log('hot', _.find(this.$store.state.hotels.hotels, function (o) {
		//     return o._id === self.$store.state.hotels.activehotel._id
		// }))
	  this.$refs[formName].validate((valid) => {
		if (valid) {
		  console.warn('save')
		  this.loading = true
		  this.$http
			.post(process.env.VUE_APP_API + '/guest/add', { guest: this.guest, range: this.range, hotel: this.$store.state.hotels.activehotel, seat: this.seat, today: this.today },
			{
			headers: {
				'Authorization': 'Bearer ' + this.$store.state.jwt.jwt
			}
			},
			).then((data) => {
			  console.log(data)
			  this.loading = false
			  this.$store.dispatch('guests/getGuests')
			  this.$store.dispatch('ombrelloni/getOmbrelloni')
			  this.$emit('closeseatDialog')
			}, (error) => {
			  console.log(error)
			  this.loading = false
			  // this.error.state = true
			  // this.error.message = error.body.error
			})
		} else {
		  console.log('error submit!!')
		  // return false
		}
	  })
	},
	proceedtoPayment (formName) {
	  this.$refs[formName].validate((valid) => {
		if (valid) {
		  console.warn('proceedtoPayment')
		  this.steps.range = false
		  this.steps.payment = true
		} else {
		  console.log('error submit!!')
		  // return false
		}
	  })
	},
	addSeat () {
		console.log('addSeat: ', this.add)
		console.log(this.seat)
		console.log(this.range)
		this.$store.dispatch('guests/addSeat', { add: this.add, guest: this.guest, seat: this.seat, range: this.range })
		this.$emit('closeseatDialog')
	},
	update (formName) {
	  this.$refs[formName].validate((valid) => {
		if (valid) {
		  this.$store.dispatch('guests/updateGuest', {guest: this.guest, seat: this.seat, range: this.range, today: this.today})
		  this.$emit('closeseatDialog')
		} else {
		  console.log('error submit!!')
		  // return false
		}
	  })
	},
	deleteGuest (filteredGuest) {
	  this.$store.dispatch('guests/deleteGuest', {filteredGuest: filteredGuest, canceldates: this.canceldates}).then(() => {
		this.$store.dispatch('guests/getGuests')
		this.$store.dispatch('ombrelloni/getOmbrelloni')
		this.$emit('closeseatDialog')
	  })
	},
	// toBill (ombrellone, seasons) {
	toBill (ombrellone) {
		// console.log('toBill: ', ombrellone)
		var self = this
		var baseprice = 0
		// var frompricelist = 0
		var seasons
		// var items2 = []
		var items = 0
		var range = moment.range(moment(ombrellone.arrival, 'DD.MM.YYYY'), moment(ombrellone.departure, 'DD.MM.YYYY'))
		var dates = Array.from(range.by('days')).map(m => m.format('DD.MM.YYYY'))
		// console.log('dates: ', dates)
		var generalbill = []
		var matchedombrellone = _.find(this.ombrelloni, {_id: ombrellone.ombrelloneid})
		// var ombritems = []
		if (self.$store.state.hotels.activehotel.seasons.length > 0) {
			var seasonsinvolved = _.chain(dates).map(function (date) {
				// console.log(date)
				// console.log(ombrellone)
				return {
					seasons: _.find(self.$store.state.hotels.activehotel.seasons, function (o) {
						return moment(date, 'DD.MM.YYYY').isBetween(moment(o.range.start, 'DD.MM.YYYY'), moment(o.range.end, 'DD.MM.YYYY'), null, '[]')
					})
				}
			}).groupBy('seasons.name').map(function (value, key) {
				// old
				// // console.log('value, key ', value, key)
				// console.log('ombrellone.items ', ombrellone.items)
				// var items = _.chain(ombrellone.items).map((item) => {
				//     console.log(item)
				//     // console.log('go ', item.name, item.num, parseInt(_.find(_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}).items, {name: item.name})?.price))
				//     return _.find(_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}).items, {name: item.name})?.price ? parseInt(_.find(_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}).items, {name: item.name})?.price) * item.num : parseInt(_.find(_.find(value[0]?.seasons?.pricelist, {period: '1'}).items, {name: item.name})?.price)
				// }).sumBy().value()
				// console.log('items ', items)
				// // console.log('find ', _.find(self.$store.state.hotels.activehotel.segments, {ombrelloni: [{ombrelloneid: ombrellone.ombrelloneid}]}))
				// var segment = _.find(self.$store.state.hotels.activehotel.segments, {ombrelloni: [{ombrelloneid: ombrellone.ombrelloneid}]}) ?? {name: ''}
				// // console.log('segment ', segment)
				// var pricelist = _.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ?? _.find(value[0]?.seasons?.pricelist, {period: '1'})
				// // var amount = parseInt(_.find(_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}).segments, {name: segment.name})?.price) ?? 0
				// // console.log('amount ', amount)
				// // var itemsprice = parseInt(_.find(_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}).items, {name: items.name})?.price)
				// // console.log('itemsprice ', itemsprice)
				// return {
				//     name: key,
				//     days: value.length,
				//     items: items,
				//     amount: _.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ? parseInt(_.find(pricelist.segments, {name: segment.name})?.price) : parseInt(_.find(pricelist.segments, {name: segment.name})?.price * value.length)
				// }
				// old end
				// console.log('value, key ', value, key)
				var ombritems = []
				var tmpombritems = []
					var pricelist = _.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ?? _.find(value[0]?.seasons?.pricelist, {period: '1'})
					// var segment = _.find(self.$store.state.hotels.activehotel?.segments, {ombrelloni: [{ombrelloneid: ombrellone.ombrelloneid}]}) ?? {price: 0}
					var segment = _.find(self.$store.state.hotels.activehotel?.segments, {ombrelloni: [{ombrelloneid: ombrellone.ombrelloneid}]}) ?? _.find(self.$store.state.hotels.activehotel?.segments, {name: 'default'})
					// console.log('segment ', segment, ombrellone.ombrelloneid)
					_.chain(ombrellone.items).map((item) => {
						// console.log('item ', item)
						// var ombritems = []
						// var tmpombritems = []
						// console.log(item.name, item.num, parseInt(_.find(_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}).items, {name: item.name})?.price))
						var range2 = moment.range(moment(item.period.start, 'DD.MM.YYYY'), moment(item.period.end, 'DD.MM.YYYY'))
						var dates2 = Array.from(range2.by('days')).map(m => m.format('DD.MM.YYYY'))
						var itemsinseason = _.filter(dates2, function (d) {
							return moment(d, 'DD.MM.YYYY').isBetween(moment(value[0]?.seasons?.range.start, 'DD.MM.YYYY'), moment(value[0]?.seasons?.range.end, 'DD.MM.YYYY'), null, '[]') ?? []
						})
						console.log('itemsinseason ', itemsinseason)
						// var itemslist = _.find(value[0]?.seasons?.pricelist, {period: dates2.length.toString()}) ?? _.find(value[0]?.seasons?.pricelist, {period: '1'})
						// console.log('itemslist ', itemslist)
						_.forEach(item.items, function (o) {
							console.log(o.name, o.num)
							if (o.num > 0) {
								// console.log(Array(o.num))
								_.forEach(Array(o.num), (value, key) => {
									tmpombritems.push({
										name: o.name + ' #' + (key+1),
										dates: itemsinseason
									})
									// console.log(o.name + (key+1))
									if (!_.some(ombritems, {'name': o.name + ' #' + (key+1)})) {
										// console.log(o.name + ' #' + (key+1) + ' not there ')
										// _.find(ombritems, {'name': o.name + (key+1)}).dates.concat(dates2)
										// console.log('creating dates for ' + o.name + ' #' + (key+1))
										ombritems.push({
											name: o.name + ' #' + (key+1),
											dates: itemsinseason
										})
									} else {
										// console.log(o.name + ' #' + (key+1) + ' already there')
										// _.forEach(dates2, (date) => {
										//     console.log('pushing ' + date + ' to ' + o.name + (key+1))
										//     _.find(ombritems, {'name': o.name + (key+1)}).dates.push(date)
										// })
									}
								})
							}
						})
						var ombrdiff = _.differenceBy(ombritems, tmpombritems, 'name')
						if (ombrdiff.length > 0) {
							_.forEach(ombrdiff, (diff) => {
								diff.dates = _.difference(_.find(ombritems, {name: diff.name}).dates, itemsinseason)
							})
						}
					}).value()
					console.log('ombritems ', ombritems)
					// console.log('seasonsinvolved ', seasonsinvolved)
					var price = _.map(ombritems, function (itemsitem) {
						var itemslist = _.find(value[0]?.seasons?.pricelist, {period: itemsitem.dates.length.toString()}) ?? _.find(value[0]?.seasons?.pricelist, {period: '1'})
						if (pricelist) {
							console.log(_.find(value[0]?.seasons?.pricelist, {period: itemsitem.dates.length.toString()}) ? parseFloat(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price) : parseFloat(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price * itemsitem.dates.length))
							return {
								total: _.find(value[0]?.seasons?.pricelist, {period: itemsitem.dates.length.toString()}) ? parseFloat(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price) : parseFloat(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price * itemsitem.dates.length),
								prices: _.find(value[0]?.seasons?.pricelist, {period: itemsitem.dates.length.toString()}) ? parseFloat(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price) : parseFloat(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price)
							}
						} else {
							return {
								total: 0
							}
						}
					})
					console.log('price ', price)
					generalbill.push({
						name: key,
						days: {
							total: value.length
						},
						items: {
							total: _.sumBy(_.map(price, 'total')),
							ombritems: ombritems
						},
						amount: pricelist ? (_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ? parseFloat(_.find(pricelist.segments, {name: segment.name})?.price) : parseFloat(_.find(pricelist.segments, {name: segment.name})?.price * value.length)) : 0
					})
					return {
						name: key,
						days: value.length,
						// items: items,
						items: _.sumBy(_.map(price, 'total')),
						// items: 0,
						amount: pricelist ? (_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ? parseFloat(_.find(pricelist?.segments, {name: segment.name})?.price) : parseFloat(_.find(pricelist.segments, {name: segment.name})?.price * value.length) || 0) : 0
						// amount: pricelist ? (_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ? parseInt(_.find(pricelist.segments, {name: segment.name})?.price) : 0) : 0
						// amount: 1
					}
			}).value()
			// }).sumBy(function (a) {
			//     console.log(a)
			//     return parseInt(a.amount)
			//     // return {
			//     //     amount: parseInt(a.amount),
			//     //     itemsprice: a.items
			//     // }
			// }).value()
			// console.log('seasonsinvolved ', seasonsinvolved)
			// console.log('items2 ', items2)
			// seasons.push(seasonsinvolved)
			seasons = seasonsinvolved
		} else {
			dates.forEach((date) => {
			  // console.log(date)
			  matchedombrellone.seasons.forEach((season) => {
				// console.log(season)
				if (moment(date, 'DD.MM.YYYY').isBetween(moment(season.range.start, 'DD.MM.YYYY'), moment(season.range.end, 'DD.MM.YYYY'), null, '[]')) {
				  // console.log(date + ' is in ' + season.name)
				  // ombrellone.items.forEach((item, index) => {
				  //   console.log(item, index)
				  //   // items += (parseInt(item.num) * parseInt(season.items[index]?.price))
				  // })
				  baseprice += parseInt(season.baseprice)
				}
			  })
			})
		}
		// console.log('seasons ', seasons)
		console.log('generalbill ', generalbill)
		if (seasons && seasons.length > 0) {
			var bill = {
				// ombritems: ombritems,
				dates: dates,
				baseprice: (_.sumBy(seasons, 'amount')).toFixed(2),
				items: (_.sumBy(seasons, 'items')).toFixed(2),
				total: (_.sumBy(seasons, 'amount') + _.sumBy(seasons, 'items')).toFixed(2),
				generalbill: generalbill
			}
			// console.log(_.sumBy(seasons, 'amount'))
			// console.log(self.matchedGuest.bills.push(bill))
			console.log('bill ', bill)
			console.log(ombrellone.ombrelloneid, _.find(_.find(self.$store.state.guests.guests, {_id: self.filteredGuest.guestid}).ombrelloni, {ombrelloneid: ombrellone.ombrelloneid}))
			_.find(_.find(self.$store.state.guests.guests, {_id: self.filteredGuest.guestid}).ombrelloni, {ombrelloneid: ombrellone.ombrelloneid}).bill = bill
			// ombrellone.bills = []
			// ombrellone.bills.push(bill)
			return bill
			// return {
			//     ombritems: ombritems,
			//     dates: dates,
			//     baseprice: (_.sumBy(seasons, 'amount')).toFixed(2),
			//     items: (_.sumBy(seasons, 'items')).toFixed(2),
			//     total: (_.sumBy(seasons, 'amount') + _.sumBy(seasons, 'items')).toFixed(2)
			// }
		} else {
			return {
				dates: dates,
				baseprice: baseprice.toFixed(2),
				items: items.toFixed(2),
				total: (baseprice + items).toFixed(2)
			}
		}
	}
  },
  watch: {
	range (value) {
		// console.log(value)
		if (value) {
			// console.log('ho')
			this.steps.range = true
			if (!this.add.open && !this.checkDay(this.seat.guests)) {
				console.log('seat free')
				this.guest.items = JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel.items))
			}
		}
	}
  },
  filters: {
  	toDate (date) {
  		return moment(date).format('DD.MM.YYYY')
  	},
	toCron (ombrelloni) {
		// console.log(ombrelloni)
		return _.orderBy(ombrelloni, (item) => {
			return moment(item.arrival, 'DD.MM.YYYY')
		})
	},
	toLast (items) {
		return _.last(items).items
	},
	toDrop (items) {
		// console.log('toDrop', items)
		return _.drop(items)
	},
	toToday (items, today) {
		// console.log(items, today)
		// console.log('check', moment().isBetween(moment(items.period.start, 'DD.MM.YYYY'), moment(items.period.end, 'DD.MM.YYYY'), null, '[]'))
		var item = _.filter(items, function (item) {
			// console.log('item ', item, moment(today).isBetween(moment(item.period.start, 'DD.MM.YYYY'), moment(item.period.end, 'DD.MM.YYYY'), 'day', '[]'), moment(today).isSame(moment(item.period.start, 'DD.MM.YYYY'), 'day'))
			if (item.period !== undefined) {
				// return moment(today).isBetween(moment(item.period.start, 'DD.MM.YYYY'), moment(item.period.end, 'DD.MM.YYYY'), 'day', '[]')||true
				return moment(today).isBetween(moment(item.period.start, 'DD.MM.YYYY'), moment(item.period.end, 'DD.MM.YYYY'), 'day', '[]')
			} else {
				return item
			}
		})
		// console.log(today, item)
		// if (item && item.period !== undefined) {
		if (item && item.length > 0) {
			return _.last(item).items
		} else {
			// console.log('no period ', items)
			return _.find(items).items
		}
	}
  },
  computed: {
  	tmpombrellone () {
  		return {
			arrival: moment(this.range.start).format('DD.MM.YYYY'),
			departure: moment(this.range.start).format('DD.MM.YYYY'),
			items: [{
				items: this.guest.items,
				period: {
					start: moment(this.range.start).format('DD.MM.YYYY'),
					end: moment(this.range.start).format('DD.MM.YYYY')
				}
			}],
			ombrelloneid: this.seat._id
		}
  	},
	bookingdates () {
	  // var self = this
	  // console.log('bookingrange: ', this.bookingrange)
	  return _.map(this.bookingrange, function (g, key) {
		console.log(g, key)
		return {
			highlight: 'green',
			dates: {
				start: g.start,
				end: g.end
			  },
			popover: {
				label: key
			}
		}
	  })
	},
	guestloading () {
		return this.$store.state.guests.loading
	},
	ombrelloniloading () {
		return this.$store.state.ombrelloni.loading
	},
	ombrellonebill () {
		var self = this
		var baseprice = 0
		// var frompricelist = 0
		var items = 0
		var days = []
		var seasons = []
		var alert = {
			active: false,
			messages: []
		}
		this.matchedGuest.ombrelloni.forEach((matchedombrellone) => {
			var range = moment.range(moment(matchedombrellone.arrival, 'DD.MM.YYYY'), moment(matchedombrellone.departure, 'DD.MM.YYYY'))
			var dates = Array.from(range.by('days')).map(m => m.format('DD.MM.YYYY'))
			var ombrellone = _.find(this.ombrelloni, {_id: matchedombrellone.ombrelloneid})
			// var ombritems = []
			if (self.$store.state.hotels.activehotel.seasons.length > 0) {
				var seasonsinvolved = _.chain(dates).map(function (date) {
					return {
						seasons: _.find(self.$store.state.hotels.activehotel.seasons, function (o) {
							return moment(date, 'DD.MM.YYYY').isBetween(moment(o.range.start, 'DD.MM.YYYY'), moment(o.range.end, 'DD.MM.YYYY'), null, '[]')
						})
					}
				}).groupBy('seasons.name').map(function (value, key) {
					console.log('value, key ', value, key)
					var segment = _.find(self.$store.state.hotels.activehotel?.segments, {ombrelloni: [{ombrelloneid: ombrellone._id}]}) ?? _.find(self.$store.state.hotels.activehotel?.segments, {name: 'default'})
					var pricelist = _.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ?? (_.find(value[0]?.seasons?.pricelist, {period: '1'}) || null)
					console.warn(pricelist)
					// var segment = _.find(self.$store.state.hotels.activehotel?.segments, {ombrelloni: [{ombrelloneid: ombrellone._id}]}) ?? {price: 0}
					console.log('segment ', segment, ombrellone._id)
					var ombritems = []
					var tmpombritems = []
					_.chain(matchedombrellone.items).map((item) => {
						// var ombritems = []
						// var tmpombritems = []
						// console.log(item.name, item.num, parseInt(_.find(_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}).items, {name: item.name})?.price))
						var range2 = moment.range(moment(item.period.start, 'DD.MM.YYYY'), moment(item.period.end, 'DD.MM.YYYY'))
						var dates2 = Array.from(range2.by('days')).map(m => m.format('DD.MM.YYYY'))
						// console.log('dates2 ', dates2)
						var itemsinseason = _.filter(dates2, function (d) {
							return moment(d, 'DD.MM.YYYY').isBetween(moment(value[0]?.seasons?.range.start, 'DD.MM.YYYY'), moment(value[0]?.seasons?.range.end, 'DD.MM.YYYY'), null, '[]') ?? []
						})
						console.log('itemsinseason ', itemsinseason)
						// var itemslist = _.find(value[0]?.seasons?.pricelist, {period: dates2.length.toString()}) ?? _.find(value[0]?.seasons?.pricelist, {period: '1'})
						// console.log('itemslist ', itemslist)
						_.forEach(item.items, function (o) {
							// console.log(o.name, o.num)
							if (o.num > 0) {
								// console.log(Array(o.num))
								_.forEach(Array(o.num), (value, key) => {
									tmpombritems.push({
										name: o.name + ' #' + (key+1),
										dates: itemsinseason
									})
									// console.log(o.name + (key+1))
									if (!_.some(ombritems, {'name': o.name + ' #' + (key+1)})) {
										// console.log(o.name + ' #' + (key+1) + ' not there ')
										// _.find(ombritems, {'name': o.name + (key+1)}).dates.concat(dates2)
										// console.log('creating dates for ' + o.name + ' #' + (key+1))
										ombritems.push({
											name: o.name + ' #' + (key+1),
											dates: itemsinseason
										})
									} else {
										// console.log(o.name + ' #' + (key+1) + ' already there')
										// _.forEach(dates2, (date) => {
										//     console.log('pushing ' + date + ' to ' + o.name + (key+1))
										//     _.find(ombritems, {'name': o.name + (key+1)}).dates.push(date)
										// })
									}
								})
							}
						})
						// console.log('ombritems ', ombritems)
						// console.log('tmpombritems ', tmpombritems)
						var ombrdiff = _.differenceBy(ombritems, tmpombritems, 'name')
						// console.log('difference', ombrdiff)
						if (ombrdiff.length > 0) {
							// console.log('need to check items')
							_.forEach(ombrdiff, (diff) => {
								// console.log(diff.name, _.find(ombritems, {name: diff.name}), ombritems[1])
								// console.log(_.difference(_.find(ombritems, {name: diff.name}).dates, dates2))
								diff.dates = _.difference(_.find(ombritems, {name: diff.name}).dates, itemsinseason)
								// console.log(diff.name, _.find(ombritems, {name: diff.name}))
							})
						}
						// console.log('ombritems after', ombritems)
						// console.log('item ', item, dates2.length, _.merge(item.items))
					}).value()
					// console.log('seasonsinvolved ', seasonsinvolved)
					var price = _.map(ombritems, function (itemsitem) {
						// console.log('itemsitem2 ', itemsitem)
						var itemslist = _.find(value[0]?.seasons?.pricelist, {period: itemsitem.dates.length.toString()}) ?? _.find(value[0]?.seasons?.pricelist, {period: '1'})
						// console.log('itemslist 2 ', itemslist)
						// console.log('itemsitem ', itemsitem, itemsitem.name.split('#').shift(), _.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()}))
						// console.log('itemsitem ', itemsitem, _.find(itemslist.items, {name: itemsitem.name})?.price, (_.find(itemslist.items, {name: itemsitem.name})?.price * itemsitem.num))
						if (pricelist) {
							// console.log(itemsitem.dates)
							// console.log(_.find(value[0]?.seasons?.pricelist, {period: itemsitem.dates.length.toString()}) ? parseInt(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price) : parseInt(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price * itemsitem.dates.length))
							return _.find(value[0]?.seasons?.pricelist, {period: itemsitem.dates.length.toString()}) ? parseFloat(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price) : parseFloat(_.find(itemslist.items, {name: itemsitem.name.split('#').shift().trim()})?.price * itemsitem.dates.length)
						} else {
							return 0
						}
					})
					// console.log('price 2 ', price, _.sumBy(price))
					// console.log('ombritems after 2', ombritems)
					// }).value()
					// console.log('items ', items)
					// console.log('amount ', _.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ? parseFloat(_.find(pricelist?.segments, {name: segment.name})?.price) : parseFloat(_.find(pricelist?.segments, {name: segment.name})?.price * value.length) || 0)
					// console.log(_.find(pricelist.segments, {segmentid: segment.segmentid}) ? 'segment found in pricelist' : 'not found: ' + segment.name + ' in ' + key)
					_.find(pricelist?.segments, {segmentid: segment.segmentid}) ?? (alert.active = true, alert.messages.push('Il segmento ' + segment.name + ' non ha prezzo per la stagione ' + key || ''))
					// pricelist.period === value.length.toString() ? parseFloat(_.find(pricelist.segments, {segmentid: segment.segmentid})?.price) || parseFloat(_.find(pricelist.segments, {name: 'default'}).price) : (alert.active = true, alert.messages.push('Il segmento ' + segment.name + ' non ha prezzo impostato per ' + value.length + ' giorni nella stagione ' + key))
					// console.log('amount ', _.find(pricelist.segments, {segmentid: segment.segmentid}) ? parseFloat(_.find(pricelist?.segments, {segmentid: segment.segmentid})?.price) : parseFloat(_.find(pricelist.segments, {name: 'default'})?.price * value.length) || 0)
					// console.log('amount ', pricelist.period === value.length.toString() ? parseFloat(_.find(pricelist.segments, {segmentid: segment.segmentid})?.price) || parseFloat(_.find(pricelist.segments, {name: 'default'}).price) : 'noprice for ' + value.length + ' days in ' + key + ' for ' + segment.name)
					// console.log('amount2 ', pricelist.period === value.length.toString() ? _.find(pricelist.segments, {segmentid: segment.segmentid})?.price ?? parseFloat(_.find(pricelist.segments, {name: 'default'}).price) : parseFloat(_.find(pricelist.segments, {segmentid: segment.segmentid})?.price * value.length) || 0)
					// console.warn(_.find(pricelist?.segments, {segmentid: segment.segmentid}), segment.name, segment.price)
					// console.log('here ', _.find(value[0]?.seasons?.pricelist, (o) => { return o.period === value.length.toString() }), value[0]?.seasons?.pricelist, value.length.toString())
					// console.log('here ', parseFloat(_.find(pricelist?.segments, {name: segment.name})?.price).toFixed(2))
					// console.log('amount: ', pricelist ? (_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ? parseInt(_.find(pricelist.segments, {name: segment.name})?.price) : 0) : 0)
					// console.log('pricelist ', pricelist, segment)
					console.log(alert)
					return {
						name: key,
						days: value.length,
						alert: alert,
						// items: items,
						items: _.sumBy(price),
						// items: 0,
						// amount: pricelist ? (_.find(pricelist.segments, {segmentid: segment.segmentid}) ? parseFloat(_.find(pricelist.segments, {segmentid: segment.segmentid})?.price) : parseFloat(_.find(pricelist.segments, {name: segment.name})?.price * value.length) || 0) : 0
						amount: pricelist ? (pricelist.period === value.length.toString() ? parseFloat(_.find(pricelist.segments, {segmentid: segment.segmentid})?.price) || parseFloat(_.find(pricelist.segments, {name: 'default'}).price) : parseFloat(_.find(pricelist.segments, {segmentid: segment.segmentid})?.price * value.length) || 0) : 0
						// amount: pricelist ? (_.find(value[0]?.seasons?.pricelist, {period: value.length.toString()}) ? parseInt(_.find(pricelist.segments, {name: segment.name})?.price) : 0) : 0
						// amount: 1
					}
				}).value()
				// }).sumBy(function (a) {
				//     return parseInt(a.amount)
				// }).value()
				_.forEach(seasonsinvolved, (item) => {
				  seasons.push(item)
				})
				// seasons.push(seasonsinvolved)
			} else {
				console.warn('no seasons at all')
				dates.forEach((date) => {
					console.log(date)
					days.push(date)
					this.$store.state.hotels.activehotel.seasons.forEach((season) => {
						if (moment(date, 'DD.MM.YYYY').isBetween(moment(season.range.start, 'DD.MM.YYYY'), moment(season.range.end, 'DD.MM.YYYY'), null, '[]')) {
							console.log(season.baseprice)
							matchedombrellone.items.forEach((item, index) => {
								console.log(item, index)
								// items += (parseInt(item.num) * parseInt(season.items[index]?.price))
							})
							baseprice += parseInt(season.baseprice)
							// console.log(items)
						}
					})
				})
			}
		})
		// console.log(_.sumBy(seasons))
		// var listbill = 0
		// console.log(seasons)
		if (seasons.length > 0) {
			// console.log('seasons ', _.sumBy(seasons, 'items'))
			console.log(alert)
			return {
				alert: alert,
				days: days,
				baseprice: (_.sumBy(seasons, 'amount')).toFixed(2),
				items: (_.sumBy(seasons, 'items')).toFixed(2),
				total: (_.sumBy(seasons, 'amount') + _.sumBy(seasons, 'items')).toFixed(2)
			}
		} else {
			console.log('no segments ', baseprice.toFixed(2))
			return {
				days: days,
				baseprice: baseprice.toFixed(2),
				// items: items.toFixed(2),
				items: 0,
				total: (baseprice + items).toFixed(2)
			}
		}
	},
	seasons () {
		return this.$store.state.hotels.activehotel.seasons
	},
	attributes () {
		return [{
			highlight: 'gray',
			dates: {
				start: this.range.start,
				end: this.range.end
			}
		}]
	},
	// periodes: {
	//     // getter
	//     get () {
	//       console.log('periodes: ', this.guest.items)
	//       var dates = []
	//         dates = _.map(this.guest.items, function (o) {
	//             return {
	//                 start: o.period.start,
	//                 end: o.period.end
	//                 // items: o.items
	//             }
	//         })
	//         console.log(dates)
	//         return [{
	//             highlight: 'gray',
	//             dates: dates
	//             // popover: {
	//             //   label: dates,
	//             // }
	//         }]
	//     },
	//     // setter
	//     set (newValue) {
	//       console.log('newValue ', newValue)
	//       this.guest.items = _.map(newValue, function (o) {
	//         return {
	//             period: {
	//                 start: moment(o.start).format('DD.MM.YYYY'),
	//                 end: moment(o.end).format('DD.MM.YYYY')          
	//             }
	//         }
	//       })
	//       // this.guest.items.push({
	//       //   period: {
	//       //       start: moment(newValue.start).format('DD.MM.YYYY'),
	//       //       end: moment(newValue.end).format('DD.MM.YYYY')
	//       //   }
	//       // })
	//     }
	//   },
	periodes () {
		// console.log('periodes: ', this.guest.items)
		var dates = _.map(this.guest.items, function (o) {
			return {
				start: o.period.start,
				end: o.period.end
				// items: o.items
			}
		})
		console.log('dates ', dates)
		return [{
			highlight: 'gray',
			dates: dates,
		}]
		// _.forEach(this.$store.state.hotels.activehotel.items, () => {
		//       console.log(dates)
		//     })
		// return [
		//     // Attributes for todos
		//     // _.forEach(this.$store.state.hotels.activehotel.items, () => {
		//     //   return  {
		//     //         dates: dates,
		//     //         dot: 'red'
		//     //     }
		//     // })
		//     ...this.$store.state.hotels.activehotel.items.map(item => ({
		//         highlight: 'gray',
		//       dates: _.chain(this.guest.items).map(function (o) {
		//             return {
		//                 start: o.period.start,
		//                 end: o.period.end
		//             }
		//         }).value(),
		//       dot: {
		//         // color: item.color,
		//         class: _.map(this.guest.items, (item2) => {
		//             return _.map(item2.items, (it) => {
		//                 console.log(it.num, it.name, item.name)
		//                 if (it.num > 0 && it.name === item.name) {
		//                     return true
		//                 }
		//             })
		//         }) ? 'opacity-75' : '',
		//       },
		//       // dot: true,
		//       popover: {
		//         label: item.name,
		//       },
		//       customData: item,
		//     })),
		//   ]
		// return [{
		//     // highlight: 'gray',
		//     dates: dates,
		//     dot: true
		//     // popover: {
		//     //   label: dates,
		//     // }
		// },
		// {
		//     dates: dates,
		//     dot: 'red'
		// },
		// {
		//     dates: dates,
		//     bar: true
		// }]
	},
	hotel () {
		// console.table(this.$store.state.hotels.activehotel.items)
		return this.$store.state.hotels.activehotel
	},
	filteredGuest () {
		var self = this
		// console.log('seat: ', _.find(self.$store.state.guests.guests, self.seat._id), self.guest)
		return _.chain(this.seat.guests).find(function (o) {
			// console.log(o)
			return moment(self.today).isBetween(moment(o.arrival, ['YYYY-MM-DD', 'DD.MM.YYYY']), moment(o.departure, ['YYYY-MM-DD', 'DD.MM.YYYY']), 'day', '[]')
		// }).assign().value()
		}).value()
	},
	matchedGuest () {
		var self = this
		return _.chain(this.$store.state.guests.guests).find(function (o) {
			// console.log(o)
			return o._id === self.filteredGuest.guestid
		}).value()
	},
	matchedPass () {
		var pass = _.find(this.$store.state.guests.passes, {_id: this.matchedGuest.passid})
		// console.log(this.$store.state.guests.passes, this.matchedGuest.passid)
		return pass
	},
	disabledDates () {
		return _.chain(this.seat.guests).map(function (value) {
			// console.log(value)
			return {
				start: value.arrival,
				end: value.departure
			}
		}).value()
	},
	disabledDatesEdit () {
		var self = this
		return _.chain(this.seat.guests).filter(function (o) {
			// console.log(self.guestid, o.guestid)
			// return moment(o.arrival, ['DD.MM.YYYY', 'YYYY-MM-DD']).format() !== moment(self.range.start, ['DD.MM.YYYY', 'YYYY-MM-DD']).format()
			return o.guestid !== self.guestid
		}).map(function (g) {
			return {
				start: g.arrival,
				end: g.departure
			}
		}).value()
	},
	enabledDatesEdit () {
		// var self = this
		return this.range
		// return _.chain(this.seat.guests).filter(function (o) {
		//     return o.guestid === self.guestid
		// }).map(function (g) {
		//     return {
		//         start: g.arrival,
		//         end: g.departure
		//     }
		// }).value()
	}
  },
  beforeMount () {
	// console.table(this.$store.state.guests.guest.items)
	// console.log('seat created')
	if (!this.add.open && !this.checkDay(this.seat.guests)) {
		console.log('seat free')
		this.guest.items = JSON.parse(JSON.stringify(this.$store.state.hotels.activehotel.items))
		console.warn(this.guest.items)
	}
	if (this.add.open) {
		console.log('beforeMount ', _.last(this.add.guest.items).items)
		this.guest.items = JSON.parse(JSON.stringify(_.last(this.add.guest.items).items))
		console.warn(this.guest.items)
	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
